import React from 'react';
import { useTranslation } from 'react-i18next';
import BankIDAuth from '../bank-id-auth';

/**
 * Inline BankID component for the sign-in page.
 * Renders as an in-page card with no overlay/modal backdrop.
 *
 * This is intentionally separate from BankIDAuth (which is used by
 * create-invoice.page.tsx as a full overlay modal) so that styling and
 * behaviour changes here cannot affect that modal.
 */

interface BankIDSigninInlineProps {
    onSuccess?: (userData: any) => void;
}

const BankIDSigninInline: React.FC<BankIDSigninInlineProps> = ({ onSuccess }) => {
    const { t } = useTranslation();

    return (
        <BankIDAuth
            mode="login"
            className="bankid-signin-inline"
            showCloseButton={false}
            onSuccess={onSuccess}
            title={t('SIGNING_IN_WITH_BANK_ID')}
            skipSameDevicePolling={true}
            autoReloadOnExpiry={true}
        />
    );
};

export default BankIDSigninInline;
